import {config} from '../config';

const getIsTradeInBannerEnabledByType = (deviceType) => {
    const deviceTypeList = config.data.tradeInBannerEnabled;

    return deviceTypeList?.some((item) => item === deviceType);
};

export default {
    getIsTradeInBannerEnabled: (deviceType) => getIsTradeInBannerEnabledByType(deviceType),
};
